import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _dark, _defineStyle;
// src/components/tooltip.ts
import { defineStyle, defineStyleConfig } from "@chakra-ui/styled-system";
import { cssVar } from "@chakra-ui/theme-tools";
var $bg = cssVar("tooltip-bg");
var $fg = cssVar("tooltip-fg");
var $arrowBg = cssVar("popper-arrow-bg");
var baseStyle = defineStyle((_defineStyle = {
  bg: $bg.reference,
  color: $fg.reference
}, _defineProperty(_defineStyle, $bg.variable, "colors.gray.700"), _defineProperty(_defineStyle, $fg.variable, "colors.whiteAlpha.900"), _defineProperty(_defineStyle, "_dark", (_dark = {}, _defineProperty(_dark, $bg.variable, "colors.gray.300"), _defineProperty(_dark, $fg.variable, "colors.gray.900"), _dark)), _defineProperty(_defineStyle, $arrowBg.variable, $bg.reference), _defineProperty(_defineStyle, "px", "2"), _defineProperty(_defineStyle, "py", "0.5"), _defineProperty(_defineStyle, "borderRadius", "sm"), _defineProperty(_defineStyle, "fontWeight", "medium"), _defineProperty(_defineStyle, "fontSize", "sm"), _defineProperty(_defineStyle, "boxShadow", "md"), _defineProperty(_defineStyle, "maxW", "xs"), _defineProperty(_defineStyle, "zIndex", "tooltip"), _defineStyle));
var tooltipTheme = defineStyleConfig({
  baseStyle: baseStyle
});
export { tooltipTheme };